var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeachIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8897 10.7344L14.1514 17.8347C14.1655 17.9183 14.1538 18.0042 14.1177 18.081C14.0817 18.1577 14.0231 18.2217 13.9498 18.2642C13.8764 18.3068 13.7919 18.3259 13.7073 18.3191C13.6228 18.3123 13.5424 18.2799 13.4768 18.2261L10.4955 15.9884C10.3515 15.8809 10.1767 15.8228 9.99703 15.8228C9.81737 15.8228 9.64253 15.8809 9.49861 15.9884L6.51225 18.2253C6.44672 18.2789 6.3664 18.3113 6.28198 18.3182C6.19756 18.325 6.11307 18.3059 6.03978 18.2635C5.96649 18.221 5.90788 18.1572 5.87177 18.0806C5.83566 18.004 5.82377 17.9182 5.83769 17.8347L7.09853 10.7344",
    stroke: "#EC003F",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99279 11.6594C12.7524 11.6594 14.9895 9.42232 14.9895 6.66272C14.9895 3.90311 12.7524 1.66602 9.99279 1.66602C7.23319 1.66602 4.99609 3.90311 4.99609 6.66272C4.99609 9.42232 7.23319 11.6594 9.99279 11.6594Z",
    stroke: "#EC003F",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachIcon);
export default __webpack_public_path__ + "static/media/BeachIcon.fb274411a0ba9b3a0bc3ecbc2fdc397f.svg";
export { ForwardRef as ReactComponent };